// Tracking Events Constants
export const TRACKING_EVENTS = {
  FILTER_INTERACTION: 'Filter Interaction',
  SORT_INTERACTION: 'Sort Interaction'
}

export const FILTER_ACTIONS = {
  SELECT: 'select',
  REMOVE: 'remove',
  CLEAR_ALL: 'clear_all'
}

export const SORT_ACTIONS = {
  SELECT: 'select'
}

export const PLATFORMS = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
}

export const FILTER_TYPES = {
  GENRE: 'genre',
  MOOD: 'mood',
  INSTRUMENT: 'instrument',
  RELEASE_TYPE: 'release_type',
  PACKAGE: 'package',
  MARKET: 'market',
  VERSION: 'version',
  ALL: 'all'
}

export const FILTER_LABELS = {
  ALL_FILTERS: 'all_filters'
}

// `source` and `trigger` values reported with the Play Song event
export const PLAY_SOURCES = {
  RELEASES: 'releases',
  RELEASE_MODAL: 'release_modal',
  RELEASE_INFORMATION: 'release_information',
  PLAYLISTS: 'playlists',
  PLAYLIST_DETAIL: 'playlist_detail',
  FLAGGED: 'flagged',
  ARCHIVED: 'archived',
  HISTORY: 'history',
  SEARCH: 'search',
  QUEUE: 'queue',
  PLAYBAR: 'playbar',
  AUTOPLAY: 'autoplay',
  UNKNOWN: 'unknown'
}

export const PLAY_TRIGGERS = {
  TILE: 'tile',
  ROW: 'row',
  RESULT: 'result',
  PLAY_ALL: 'play_all',
  COVER_ART: 'cover_art',
  HEADER_MENU: 'header_menu',
  TRACK_MENU: 'track_menu',
  NEXT: 'next',
  PREVIOUS: 'previous',
  RESTART: 'restart',
  LAST_SESSION: 'last_session',
  REPLAY: 'replay',
  TRACK_ENDED: 'track_ended',
  REMOVE_CURRENT: 'remove_current',
  UNKNOWN: 'unknown'
}
